import React from 'react';
import classes from './LoadingIndicator.module.scss';

interface LoadingIndicatorProps {
  label: string;
  variant?: 'inline' | 'block';
  className?: string;
}

export default function LoadingIndicator({label, variant = 'block', className}: LoadingIndicatorProps) {
  return (
    <span role="status" aria-label={label} className={[classes.indicator, classes[variant], className].filter(Boolean).join(' ')}>
      <span className={classes.dots} aria-hidden="true">
        <span className={classes.dot}/>
        <span className={classes.dot}/>
        <span className={classes.dot}/>
      </span>
    </span>
  );
}
